import { Buffer } from 'buffer';

// Add Buffer to window for global access
window.Buffer = Buffer;
